<template>
  <div class="TeacherAdminIndex" :class="{ TeacherAdminDef: isDom == 0 }">
    <div
      class="consultAddConsult"
      @click="$parent.consultAddConsult"
      v-if="getPage == 'TeacherAdminIndex'"
    >
      发起咨询
    </div>
    <el-tabs
      class="el_tabs_common w_bfb"
      v-if="isDom == 1 && tabs.length > 0"
      v-model="params.is_my"
    >
      <el-tab-pane
        v-for="(item, index) in tabs"
        :key="index"
        :name="item.name"
        :label="item.label"
      ></el-tab-pane>
    </el-tabs>
    <div class="w_bfb">
      <div class="main_left">
        <div
          class="w_bfb consultUpvoteStatus"
          v-for="(item, index) in list"
          :key="item.id"
        >
          <div class="consult_list">
            <div class="avatar">
              <img :src="item.avatar" />
            </div>
            <div class="right_main">
              <div class="nickname w_bfb">{{ item.nickname }}</div>
              <div class="w_bfb">
                <div class="is_top" v-if="item.is_top == 2">置顶</div>
                <div
                  class="is_recover status1"
                  v-if="item.recover_info && item.recover_info.id > 0"
                >
                  已回答
                </div>
                <div class="is_recover status2" v-else>未回答</div>
                <div class="title">{{ item.title }}</div>
              </div>
              <div class="w_bfb details" v-html="item.details"></div>
              <div class="w_bfb date_upvote">
                <span class="created_at">
                  {{ item.created_at | tsFormat("yyyy-MM-dd hh:mm") }}
                </span>
                <span
                  class="icon_zan"
                  :class="item.is_upvote == 1 ? 'active' : ''"
                  @click="$parent.handleZan(item)"
                >
                  {{ item.upvote_num }}
                </span>
                <span
                  class="delete"
                  v-if="
                    item.is_my_create == 1 &&
                    (getPage == 'TeacherAdminIndex' ||
                      getPage == 'MemberMyConsultation')
                  "
                  @click="$parent.delConsult(item)"
                >
                  删除
                </span>
                <span
                  class="reply"
                  v-if="
                    item.is_recover == 1 &&
                    isDom == 1 &&
                    getPage == 'TeacherConsultTeacherIndex'
                  "
                  @click="$parent.consultAddConsult(item, index)"
                >
                  写回答
                </span>
              </div>
            </div>
          </div>
          <div
            class="consult_list fafafa"
            v-if="item.recover_info && item.recover_info.id > 0"
          >
            <div
              class="avatar"
              v-if="getPage == 'MemberMyConsultation'"
              @click="onClickTeacher(item)"
              style="cursor: pointer"
            >
              <img :src="item.recover_info.avatar" />
            </div>
            <div class="avatar" v-else>
              <img :src="item.avatar" />
            </div>
            <div class="right_main">
              <div class="nickname w_bfb">
                {{ item.recover_info.real_name }}
              </div>
              <div
                class="w_bfb details"
                v-html="item.recover_info.content"
              ></div>
              <div class="w_bfb image">
                <el-image
                  v-for="(img, idx) in item.recover_info.image"
                  :src="img"
                  :key="idx"
                  :preview-src-list="item.recover_info.image"
                ></el-image>
              </div>
              <div class="w_bfb date_upvote">
                <span class="created_at">
                  {{
                    item.recover_info.created_at | tsFormat("yyyy-MM-dd hh:mm")
                  }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="w_bfb" v-if="total > limit && isDom == 1">
          <el-pagination
            background
            @current-change="$parent.handlePageChange"
            :current-page="page"
            :page-size="limit"
            layout="prev, pager, next"
            :total="total"
          ></el-pagination>
        </div>
        <div class="w_bfb" v-if="isData == 0" style="padding: 100px 0px">
          <EmptyNew class="empty" title="暂无数据" />
        </div>
      </div>
      <div
        class="recover_num_not_recover_num"
        v-if="isDom == 1 && detail && detail.recover_num"
      >
        <div class="title">咨询统计</div>
        <div class="not_recover_num">
          <span>
            已回复
            <br />
            （{{ detail.recover_num }}）
          </span>
          <span>
            待回复
            <br />
            （{{ detail.not_recover_num }}）
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EmptyNew from "@/components/EmptyNew.vue";
export default {
  name: "ConsultUpvoteStatus",
  components: {
    EmptyNew,
  },
  props: {
    tabs: {
      type: Array,
      default() {
        return [];
      },
    },
    params: {
      type: Object,
      default: () => {
        return {};
      },
    },
    detail: {
      type: Object,
      default: () => {
        return {};
      },
    },
    isDom: {
      type: Number,
      default: 1,
    },
    isData: {
      type: Number,
      default: 1,
    },
    page: {
      type: Number,
      default: 1,
    },
    limit: {
      type: Number,
      default: 1,
    },
    total: {
      type: Number,
      default: 1,
    },
    getPage: {
      type: String,
      default: "",
    },
    list: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  computed: {},
  methods: {
    onClickTeacher(item) {
      this.$router.push({
        name: "ShowTeachersDetaial",
        params: {
          id: item.teacher_id,
        },
        query: {
          route_name: "ShowAppointmentTeachers",
          route_label: "课时约课老师",
          title: this.$route.query.title,
          recommend: this.$route.query.recommend,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.consultUpvoteStatus {
  border-bottom: 1px solid rgba(153, 153, 153, 0.1);
  padding-bottom: 20px;
}
/deep/ {
  .el_tabs_common {
    .el-tabs__nav-wrap {
      padding-left: 30px;
      box-sizing: border-box;
    }
    .el-tabs__active-bar {
      display: none;
    }

    .el-tabs__item {
      height: 45px;
      line-height: 45px;
      font-size: 18px;
      font-weight: 400;
      color: #000;
      padding: 0;
      margin-right: 40px;
      box-shadow: none !important;

      &.is-active {
        font-weight: 500;
      }

      &.is-active::after {
        content: "";
        position: absolute;
        width: calc(100% - 10px);
        height: 4px;
        background: $primary-color;
        border-radius: 100px 100px 0px 0px;
        left: 50%;
        transform: translateX(-50%);
        bottom: 0;
      }
    }

    .el-tabs__nav-wrap::after {
      height: 1px;
      background-color: #ededed;
    }
  }
}
.TeacherAdminIndex {
  width: 100%;
  padding: 18px;
  padding-top: 10px;
  box-sizing: border-box;
  background: #ffffff;
  border-radius: 8px;
  float: left;
  position: relative;
  .consultAddConsult {
    padding: 0px 10px 0px 26px;
    width: auto;
    position: absolute;
    top: 10px;
    right: 18px;
    height: 28px;
    line-height: 28px;
    text-align: center;
    font-size: 12px;
    color: #fff;
    cursor: pointer;
    z-index: 111;
    background: #bb1c20 url(~@/assets/images/oto/teacherAdminIndex1.png)
      no-repeat 10px 6px;
    background-size: 16px 16px;
    border-radius: 4px;
    border: 0px;
    box-shadow: 0px 2px 8px 0px rgba(32, 32, 32, 0.2);
  }
  .main_left {
    width: 900px;
    float: left;
    padding-left: 30px;
    .consult_list {
      width: 100%;
      float: left;
      margin-top: 30px;
      .avatar {
        width: 48px;
        height: 48px;
        float: left;
        img {
          width: 48px;
          height: 48px;
          border-radius: 50%;
        }
      }
      .right_main {
        float: right;
        width: calc(100% - 70px);
        .nickname {
          height: 25px;
          font-size: 18px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: bold;
          text-align: left;
          color: #000000;
          line-height: 25px;
          padding-bottom: 10px;
        }
        .is_top {
          float: left;
          margin-right: 10px;
          height: 24px;
          line-height: 24px;
          background: $primary-color;
          border-radius: 2px;
          box-shadow: 0px 2px 4px 0px rgba(210, 39, 49, 0.1);
          color: #fff;
          font-size: 12px;
          padding: 0px 6px;
        }
        .is_recover {
          float: left;
          margin-right: 10px;
          height: 24px;
          line-height: 24px;

          border-radius: 2px;

          font-size: 12px;
          padding: 0px 6px;
        }
        .status1 {
          background: rgba(36, 208, 195, 0.1);
          color: #25c3b7;
        }
        .status2 {
          background: rgba(153, 153, 153, 0.1);
          color: #999999;
        }
        .title {
          float: left;
          height: 24px;
          line-height: 24px;
          font-size: 16px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: normal;
          text-align: left;
          color: #333333;
        }
        .details {
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: normal;
          text-align: left;
          color: #666666;
          line-height: 24px;
          margin-top: 5px;
        }
        .image {
          .el-image {
            width: 140px;
            height: 140px;
            float: left;
            margin: 10px 10px 0px 0px;
          }
        }
        .date_upvote {
          float: left;
          margin-top: 10px;
          span {
            height: 28px;
            line-height: 28px;
          }
          .created_at {
            background: url(~@/assets/images/oto/created_at.png) no-repeat 0px
              2px;
            background-size: 24px 24px;
            float: left;
            color: #999;
            padding-left: 30px;
            margin-right: 30px;
          }
          .delete {
            background: url(~@/assets/images/oto/delete.png) no-repeat 0px 2px;
            background-size: 24px 24px;
            float: right;
            padding-left: 26px;
            color: rgba(153, 153, 153, 0.9);
            font-size: 14px;
            cursor: pointer;
          }
          .reply {
            background: rgba(208, 36, 45, 0.1)
              url(~@/assets/images/oto/reply.png) no-repeat 10px 4px;
            background-size: 18px 18px;
            float: right;
            padding-left: 30px;
            padding-right: 10px;
            color: $primary-color;
            font-size: 14px;
            cursor: pointer;
            border-radius: 4px;
          }
          .icon_zan {
            background: url(~@/assets/images/oto/upvote_num.png) no-repeat 0px
              2px;
            background-size: 24px 24px;
            float: left;
            padding-left: 28px;
            margin-right: 30px;
            color: #999;
            font-size: 14px;
            cursor: pointer;
          }
          .icon_zan.active {
            background: url(~@/assets/images/oto/upvote_num_active.png)
              no-repeat 0px 2px;
            background-size: 24px 24px;
            color: $primary-color;
          }
        }
      }
    }
    .fafafa {
      background: #fafafa;
      border-radius: 8px;
      box-sizing: border-box;
      padding: 16px;
      .right_main {
        .nickname {
          padding-bottom: 0px;
        }
      }
    }
  }
  .recover_num_not_recover_num {
    float: right;
    background: url(~@/assets/images/oto/teacherAdminIndex2.png) no-repeat;
    background-size: 160px 180px;
    width: 160px;
    height: 180px;
    margin-top: 20px;
    color: #fff;
    .not_recover_num {
      width: 100%;
      float: left;
      padding-left: 20px;
      box-sizing: border-box;
      margin-top: 30px;
      font-size: 14px;
      line-height: 24px;
      span {
        width: 50%;
        float: left;
      }
    }
    .title {
      height: 22px;
      font-size: 16px;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: Medium;
      line-height: 22px;
      width: 100%;
      float: left;
      padding-left: 30px;
      box-sizing: border-box;
      position: relative;
      margin-top: 30px;
      &::before {
        width: 3px;
        height: 14px;
        background: #ffffff;
        border-radius: 2px;
        content: "";
        position: absolute;
        left: 20px;
        top: 3px;
      }
    }
  }
}
.TeacherAdminDef {
  padding: 0px;
  .main_left {
    width: 100%;
    padding: 0px;
  }
  .consult_list {
    margin: 0px !important;
  }
}
</style>
